module.exports = __webpack_public_path__ + "media/images/flags/1x1/gin-094da31f4f1bcab80443b846b6f294d3.svg";